import { useAddArticleLike } from '@web/newsfeed/hooks/useAddArticleLike';
import { useRemoveArticleLike } from '@web/newsfeed/hooks/useRemoveArticleLike';
import { useToggleLike } from '@web/newsfeed/hooks/useToggleLike';

import { useArticleSearchQueryCache } from './useArticleSearchQueryCache';

export const useArticleSearchActions = () => {
  const { addArticleLike: onAddArticleLikeSuccess, removeArticleLike: onRemoveArticleLikeSuccess } =
    useArticleSearchQueryCache();

  const addLikeMutation = useAddArticleLike(onAddArticleLikeSuccess);
  const removeLikeMutation = useRemoveArticleLike(onRemoveArticleLikeSuccess);
  const toggleLike = useToggleLike(addLikeMutation, removeLikeMutation);

  return { toggleLike };
};
